<script setup lang="ts">
import Quote from '~/assets/icons/quote.svg?component'
import type {Populated} from '~/types/populated'
import type {AboutUs} from '~/types/legacy'

const props = defineProps<{
  data: Populated<AboutUs>['quote']
}>()
</script>

<template>
  <Container class="screen-content px-2">
    <div class="content-company mx-auto max-w-screen-sm rounded-lg bg-main-50 px-8 !pb-8 !pt-6 bordershadow-lg-main">
      <Quote width="42" class="mb-4 text-main-950 opacity-10" />

      <Paragraph size="medium" weight="normal" align="left" class="my-4">{{ data.message }}</Paragraph>

      <div class="flex items-center justify-start gap-x-2">
        <img src="/ceo.jpg" alt="Photo of our CEO, Maxim" class="h-12 w-12 rounded-full" />

        <Paragraph size="normal" weight="medium">
          {{ `${data.author}, ${data.role}` }}
        </Paragraph>
      </div>
    </div>
  </Container>
</template>
